import React from 'react';
import { Facebook, Youtube, Instagram, Phone, Mail, MapPin } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-dark pt-20 pb-8 border-t-4 border-accent" data-id="element-41">
      <div className="container mx-auto px-4" data-id="element-42">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16 text-center md:text-left" data-id="element-43">
          <div className="flex flex-col items-center md:items-start" data-id="element-44">
            <div className="mb-6" data-id="element-45">
              <Logo data-id="element-46" />
            </div>
            <p className="font-display text-xl text-white uppercase tracking-wide mb-2" data-id="element-47">
              Texas Proud Plumbing
            </p>
            <p className="text-slate-400 text-sm mb-6 max-w-xs" data-id="element-48">
              Commercial & Residential plumbing services from Huntsville to
              Galveston.
            </p>
            <div className="flex items-center gap-4" data-id="element-49">
              <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-accent hover:bg-accent hover:text-white transition-colors" data-id="element-50">
                <Facebook className="h-5 w-5" data-id="element-51" />
              </a>
              <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-accent hover:bg-accent hover:text-white transition-colors" data-id="element-52">
                <Instagram className="h-5 w-5" data-id="element-53" />
              </a>
              <a href="#" aria-label="YouTube" className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-accent hover:bg-accent hover:text-white transition-colors" data-id="element-54">
                <Youtube className="h-5 w-5" data-id="element-55" />
              </a>
              <a href="#" aria-label="TikTok" className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-accent hover:bg-accent hover:text-white transition-colors" data-id="element-56">
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-57">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-58" />
                </svg>
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-start" data-id="element-59">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-60">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-61">
              <li data-id="element-62">
                <a href="#services" className="text-slate-400 hover:text-accent transition-colors" data-id="element-63">
                  Services
                </a>
              </li>
              <li data-id="element-64">
                <a href="#gallery" className="text-slate-400 hover:text-accent transition-colors" data-id="element-65">
                  Before & After
                </a>
              </li>
              <li data-id="element-66">
                <a href="#reviews" className="text-slate-400 hover:text-accent transition-colors" data-id="element-67">
                  Customer Reviews
                </a>
              </li>
              <li data-id="element-68">
                <a href="#service-area" className="text-slate-400 hover:text-accent transition-colors" data-id="element-69">
                  Service Area
                </a>
              </li>
              <li data-id="element-70">
                <a href="#contact" className="text-slate-400 hover:text-accent transition-colors" data-id="element-71">
                  Book Online
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center md:items-start" data-id="element-72">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-73">
              Our Services
            </h4>
            <ul className="space-y-4" data-id="element-74">
              <li className="text-slate-400" data-id="element-75">Water Heaters</li>
              <li className="text-slate-400" data-id="element-76">Drain Cleaning</li>
              <li className="text-slate-400" data-id="element-77">Fixture Installation</li>
              <li className="text-slate-400" data-id="element-78">Leak Repair</li>
              <li className="text-slate-400" data-id="element-79">Commercial Plumbing</li>
            </ul>
          </div>

          <div className="flex flex-col items-center md:items-start" data-id="element-80">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-81">
              Contact Us
            </h4>
            <ul className="space-y-4" data-id="element-82">
              <li data-id="element-83">
                <a href="tel:281-601-5796" className="flex items-center gap-3 text-slate-400 hover:text-accent transition-colors" data-id="element-84">
                  <Phone className="h-5 w-5 text-accent" data-id="element-85" />
                  (281) 601-5796
                </a>
              </li>
              <li data-id="element-86">
                <a href="mailto:service@baxterfamilyplumbing.com" className="flex items-center gap-3 text-slate-400 hover:text-accent transition-colors" data-id="element-87">
                  <Mail className="h-5 w-5 text-accent" data-id="element-88" />
                  service@baxterfamilyplumbing.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400" data-id="element-89">
                <MapPin className="h-5 w-5 text-accent shrink-0 mt-1" data-id="element-90" />
                <span data-id="element-91">Serving Huntsville to Galveston, Texas</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-accent/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-500" data-id="element-92">
          <p data-id="element-93">
            &copy; {new Date().getFullYear()} Baxter Family Plumbing LLC. RMP
            #46433. All rights reserved.
          </p>
          <p data-id="element-94">
            Managed by{' '}
            <span className="text-slate-400 font-medium" data-id="element-95">LetLois</span>
          </p>
        </div>
      </div>
    </footer>;
}